// ログイン中のアカウントのアイコンが、起動のときなどに時折消える件（NP-USR-BUG-026）。

// ログイン中のユーザーの取得に失敗したとき、覚えているユーザーを消すか。
// 消すときは setCurrentSignin に渡す値（{}）を、残すときは null を返す。
//
// 以前は、どんな失敗でもユーザーを消していた。起動の直後はまだ通信できないことがあり、
// そのとき前回のユーザーまで消えて、アイコンと名前が出なくなっていた。
// サーバーが「この端末はログインしていない」（400）と答えたときだけ消す。
// 通信できない（応答が無い）・時間切れ・サーバーの不調（5xx）のときは残し、次の取得を待つ。
export function signinPayloadAfterError (error) {
  const status = error && error.response ? error.response.status : undefined
  if (status === 400 || status === 401 || status === 403) {
    return {}
  }
  return null
}

// アイコンの画像の URL。画像が無いとき、または読み込みに失敗したときは null（頭文字のアイコンを出す）。
// 画像はログインの cookie が要るので、起動の直後などに読み込めないことがある。以前は失敗すると
// 壊れた画像のまま何も見えなくなっていた。
export function iconImageSource (target, loadFailed) {
  if (!target || loadFailed) return null
  const path = target.icon_img_path
  if (typeof path !== 'string' || path.length === 0) return null
  return '/api' + path
}

// 頭文字のアイコンに出す 1 文字
export function iconInitial (target) {
  const name = target && typeof target.name === 'string' ? target.name : ''
  return name.charAt(0)
}
